import { z } from 'zod';
import { SiteSchema } from '@/api/schema/site';

export const BasePatientSchema = z.object({
  id: z.string(),
  humanReadableId: z.string(),
  externalId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  dateOfBirth: z.string(),
  gender: z.string(),
  email: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  address: z.string().optional().nullable(),
  site: SiteSchema,
  note: z.string().optional().nullable(),
  clinicalProcedureId: z.string().optional().nullable(),
});

export type BasePatient = z.infer<typeof BasePatientSchema>;
